import axios from 'axios'

//const API_URL = 'http://localhost:3002'
//const API_URL = 'http://192.168.0.171:3000/'
//const API_URL = 'https://ite9ixguq0.execute-api.us-east-2.amazonaws.com/prod'
//const API_URL = 'https://2vcrzfq4h3.execute-api.us-east-2.amazonaws.com/prod'
const API_URL = 'https://api.deskontime.com/'

const securedAxiosInstance = axios.create({
  baseURL: API_URL,
  //withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    //'x-api-key': 'NFNbYk3xg94knplmtOtiX7e0OFQVqfAaVdZq2Nzd' // ambiente antiguo
    'x-api-key': '1rZ2TFmScE4uEl9XcMh9n5x8x1pgEn1M4mDSsyPW'
  }
})

const plainAxiosInstance = axios.create({
  baseURL: API_URL,
  //withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    //'x-api-key': 'NFNbYk3xg94knplmtOtiX7e0OFQVqfAaVdZq2Nzd' // ambiente antiguo
    //'x-api-key': '1rZ2TFmScE4uEl9XcMh9n5x8x1pgEn1M4mDSsyPW'
  }
})

securedAxiosInstance.interceptors.request.use(config => {
  const method = config.method.toUpperCase()

  config.headers = {
    ...config.headers,
    'Authorization': 'Bearer ' + localStorage.csrf
  }
  return config
})

plainAxiosInstance.interceptors.request.use(config => {
  const method = config.method.toUpperCase()
  config.headers = {
    ...config.headers
  }
  return config
})

/*const gdriveAxiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json'
  }
})*/

/*gdriveAxiosInstance.interceptors.request.use(config => {
  const method = config.method.toUpperCase()

  config.headers = {
    ...config.headers,
    'Authorization': 'Bearer ' + localStorage.gd_api_token
  }
  return config
})*/

securedAxiosInstance.interceptors.response.use(null, error => {

  if (error.response && error.response.config && error.response.status === 401) {
  //if (error.response && error.response.config && error.response.status === 999) {
    // If 401 by expired access cookie, we do a refresh request

    //return plainAxiosInstance.post('/refresh', { user: localStorage.user_data}, { headers: { 'Authorization': 'Bearer ' + localStorage.refresh_csrf } })
    return plainAxiosInstance.post('/refresh', {}, { headers: { 'Authorization': 'Bearer ' + localStorage.csrf } })
      .then(response => {

        //console.log(response.data)

        localStorage.csrf = response.data.csrf
        //localStorage.refresh_csrf = response.data.refresh_csrf

        localStorage.signedIn = true
        // After another successfull refresh - repeat original request
        let retryConfig = error.response.config
        retryConfig.headers['Authorization'] = 'Bearer ' + localStorage.csrf
        return plainAxiosInstance.request(retryConfig)
      }).catch(error => {
        
        localStorage.clear()
        
        // redirect to signin if refresh fails
        location.replace('/')
        return Promise.reject(error)
      })
  } else {
    return Promise.reject(error)
  }
})

export { securedAxiosInstance, plainAxiosInstance}
